import {
    Vue, Component, Prop,
} from 'vue-property-decorator';

/**
 * Common Props
 */
@Component
class FormsProps extends Vue {
    /**
     * ID of the input
     */
    @Prop() id!: string;

    /**
     * Name of the input
     */
    @Prop() name!: string;

    /**
     * Form Field Label
     */
    @Prop() label!: string;
    
    /**
     * Form Field Placeholder
     */
    @Prop() placeholder!: string;
    
    /**
     * Form Field hint
     */
    @Prop() hint!: string;

    /**
     * Readonly mode
     */
    @Prop({ type: Boolean }) readonly!: boolean;

    /**
     * Disable mode
     */
    @Prop({ type: Boolean }) disabled!: boolean;

    /**
     * Hide Label of the field
     */
    @Prop({ type: Boolean }) noLabel!: boolean;

    /**
     * Default value of the field
     */
    @Prop() default!: any;

    /**
     * Value of the field (Equal to _element.value_)
     */
    @Prop() init!: any;

    /**
     * Value of the field (Equal to _element.value_)
     */
    @Prop() value!: any;

    /**
     * Validation Rules
     */
    @Prop() validation!: Array<string>;
}

export default FormsProps;
